
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/privateAppsPanel/components/InstalledAppIndicator/installedAppIndicator.scss.css.virtualfile';
        module.exports = {"installedAppIndicator":"_installedAppIndicator_1eor1_1"};